<template>
  <v-card :flat="elevation">
    <v-card-title class="subheading">Ayuda</v-card-title>
    <v-list class="pa-0 caption" dense>
      <v-list-item :to="urlFaqs">
        <v-list-item-icon>
          <v-icon color="primary">contact_support</v-icon>
        </v-list-item-icon>
        <v-list-item-content>Preguntas frecuentes</v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item target="_blank" href="/assets/ManualUsuario.pdf">
        <v-list-item-icon>
          <v-icon color="primary">school</v-icon>
        </v-list-item-icon>
        <v-list-item-content>Manual de usuario</v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item>
        <v-list-item-icon>
          <v-icon color="primary">contact_mail</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          Buzón CAU:
          <a :href="'mailto:' + soporteCorreo">{{soporteCorreo}}</a>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider class="mt-2"></v-divider>
    <v-card-actions>
      <div class="caption">
        <code class="version">Front v{{versionFront}}</code>
        <code class="version">BFF v{{versionBFF}}</code>
        <code class="version">Servicio v{{versionBack}}</code>
      </div>
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapState } from "vuex";

export default {
  props: {
    titulo: {
      type: String,
      default: "Ayuda"
    },
    urlFaqs: {
      type: String,
      default: "/FAQ"
    },
    elevation: {
      type: Boolean,
      default: false
    }
  },
  mounted() {},
  computed: mapState("global", ["versionBack", "versionBFF", "versionFront", "soporteCorreo"]),
  data() {
    return {};
  }
};
</script>
<style scoped>
code {
  margin-right: 10px;
}
</style>